/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TrendingIcon = /*#__PURE__*/ createSvgIcon(
  'TrendingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.542 15.354a.768.768 0 01-.24-.531.693.693 0 01.219-.531l4.27-4.271a1.447 1.447 0 011.063-.438c.417 0 .77.146 1.063.438l2.104 2.104 4.416-4.396H13.75a.728.728 0 01-.534-.214.72.72 0 01-.216-.531c0-.212.072-.39.216-.536a.72.72 0 01.534-.219h3.5c.212 0 .39.072.534.216a.726.726 0 01.216.534v3.5c0 .213-.072.39-.215.535a.719.719 0 01-.53.215.745.745 0 01-.536-.21.691.691 0 01-.22-.519V8.792l-4.416 4.416a1.446 1.446 0 01-1.062.438c-.417 0-.771-.146-1.063-.438l-2.104-2.125-4.25 4.271a.729.729 0 01-1.062 0z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TrendingIcon;
